import styled from '@emotion/styled/macro'

const LayoutContainer = styled('div')`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    /* padding: 0.5rem; */
    width: 100%;
    height: 100%;
    margin: 0;
    /* background: var(--colors-primary-main); */
`
export const PageContentWrapper = styled('div')`
    background: ${({ background = 'var(--colors-grays-0)' }) => background};
    align-items: center;
    align-self: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-radius: var(--borderRadius-xl);
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 912px;
    height: 100%;
    overflow: auto;
    /* box-shadow: var(--boxShadow-5); */
    @media (max-width: 912px) {
        margin-top: 0;
        margin-bottom: 0;
        border-radius: unset;
        border: none;
    }
`
export const PageContentWrapperSection = styled(PageContentWrapper)`
    border: var(--borders-main);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
`
export const MaxWidthWrapper = styled('div')`
    width: 100%;
    max-width: ${({ maxWidth = '500px' }) => maxWidth};
    height: 100%;
    display: flex;
    flex-direction: column;
    align-self: center;
`
export default LayoutContainer
